import { render, staticRenderFns } from "./PracticalExamList.vue?vue&type=template&id=12fca00c&scoped=true"
import script from "./PracticalExamList.vue?vue&type=script&lang=ts"
export * from "./PracticalExamList.vue?vue&type=script&lang=ts"
import style0 from "./PracticalExamList.vue?vue&type=style&index=0&id=12fca00c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fca00c",
  null
  
)

export default component.exports